import React from 'react';
import { useNavigate } from 'react-router-dom';

import TitleField from '../text/TitleField';

import TextField from '../text/TextField';
import Button from '../buttons/Button';
import FeatureCard from '../design/FeatureCard';

import { StaggerGroup, StaggerItem } from '../motion/Stagger';

import '../../styles/home/Hero.css';

import auburnbaylogo from '../../images/home/hero/organizations/auburnbayra.png';
import harmonylogo from '../../images/home/hero/organizations/harmonyoa.png';
import mckenzielakelogo from '../../images/home/hero/organizations/mckenzielakera.png';

import { FaRegUser } from "react-icons/fa";
import { GoStack } from "react-icons/go";
import { MdOutlineSecurity } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa";

import { useMediaQuery } from '../../hooks/useMediaQuery';

const Hero = () => {
    const navigate = useNavigate();

    // Take the user straight to the first product on the Products page
    // (the Products page reads the hash and scrolls that product into view).
    const goToFirstProduct = () => {
        navigate('/products#boathouse-renter-app'); 
    };

    const goToContactUs = () => {
        navigate('/contact');
    }

     // Mobile always shows feature cards in landscape style (icon beside
        // text) regardless of this product's own desktop orientation.
        const isMobileViewport = useMediaQuery('(max-width: 767px)');

        const isTabletViewport = useMediaQuery('(min-width: 768px) and (max-width: 1024px)');

    return (
        <>
            <section className="home-hero-section">
                <StaggerGroup as="div" className="home-hero-container" staggerChildren={0.18} delayChildren={0.1}>

                    <StaggerItem as="div" className="home-hero-title-container">
                        <h1 className="home-hero-title">
                            Software That Perfectly Fits Your <span className="home-hero-title-highlight">Niche</span>
                        </h1>
                    </StaggerItem>

                    <StaggerItem as="div" className="home-hero-subtitle-container">
                        <TextField
                        text="Custom software solutions tailored to your real workflows, operations,
                        and organization. Built to help you move faster, work smarter, and achieve more."
                        fontColor='#898989'/>
                    </StaggerItem>


                    <StaggerItem as="div" className="home-hero-buttons-container">

                        <div className="home-hero-explore-products-button-container">
                            <Button className="home-hero-explore-products-button" onClick={goToFirstProduct}>
                                <span>Products</span>
                                <FaArrowRight />
                            </Button>
                        </div>


                        <div className="home-hero-contact-us-button-container">
                            <Button type="light" className="home-hero-contact-us-button" onClick={goToContactUs}>
                                Contact Us
                            </Button>
                        </div>
                    </StaggerItem>

                    {!isMobileViewport && (
                    <StaggerItem as="div" className="home-hero-feature-card-container">

                        <FeatureCard className="home-hero-feature-card" title="Built Around You"
                            description={isTabletViewport
                                ? "Software designed around your actual workflow."
                                : "We design and build software that fits your unique processes, people, and goals, no compromises."}
                            icon={FaRegUser} orientation="landscape" />

                        <FeatureCard className="home-hero-feature-card" title="Modern & Reliable"
                            description={isTabletViewport
                                ? "Modern architecture and dependable technology."
                                : "Clean architecture, modern technology, and rigorous quality so your software just works, every time."}
                            icon={GoStack} orientation="landscape" />

                        <FeatureCard className="home-hero-feature-card" title="Secure & Scalable"
                            description={isTabletViewport
                                ? "Secure systems built to grow with you."
                                : "Enterprise-grade security and scalable systems that grow with your business and protect what matters."}
                            icon={MdOutlineSecurity} orientation="landscape" />


                    </StaggerItem>
                    )}


                    <StaggerItem as="div" className="home-hero-clients-container">

                        <div className="home-hero-clients-title-container">

                            <TitleField className="home-hero-clients-title"
                                title="Trusted by Organizations That Value Quality" bold={true} fontSize="1.5rem"/>
                        </div>

                        <div className="home-hero-clients-logos-container">

                            <div className="home-hero-clients-logo-container">
                                <img src={auburnbaylogo} alt="Client Logo" className="home-hero-clients-logo" draggable={false}/>
                            </div>

                            {/* <div className="home-hero-clients-logo-container">
                                <img src={harmonylogo} alt="Client Logo" className="home-hero-clients-logo" draggable={false}/>
                            </div> */}

                            <div className="home-hero-clients-logo-container">
                                <img src={mckenzielakelogo} alt="Client Logo" className="home-hero-clients-logo" draggable={false}/>
                            </div>

                        </div>


                    </StaggerItem>


                </StaggerGroup>
            </section>
        </>

        
    );
}


export default Hero;